import { FacebookIcon, InstagramIcon, YouTubeIcon } from './Icons'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src="/assets/media/2025/11/logo_full_light.png" alt="البيت المحمدي" />
        </div>
        <div className="footer-contact">
          <h2>كن علي تواصل</h2>
          <div className="footer-socials">
            <a href="https://www.facebook.com/albeitalmohamedi/" target="_blank" rel="noreferrer" aria-label="فيسبوك"><FacebookIcon /></a>
            <a href="https://youtube.com/@beitmohamadi?si=zTHDxQePFnCS2LAL" target="_blank" rel="noreferrer" aria-label="يوتيوب"><YouTubeIcon /></a>
            <a href="https://www.instagram.com/albeitalmohamedi?igsh=YzJpNmIzZ2Y2c21z" target="_blank" rel="noreferrer" aria-label="انستجرام"><InstagramIcon /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">© 2025 جميع الحقوق محفوظة لدي البيت المحمدي</div>
    </footer>
  )
}
